import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { CommandPalette } from '@/components/CommandPalette';
import { useChord } from '@/lib/keyboard';
import { useAppSelector } from '@/store/hooks';

import { AppSidebar } from './AppSidebar';

export function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);
  const token = useAppSelector((s) => s.auth.accessToken);

  // Vim-style nav chords. Press `g`, then within 1s press the section letter.
  // Disabled when focus is in an input/textarea (handled inside `useChord`).
  useChord(['g', 'd'], () => navigate('/app'));
  useChord(['g', 't'], () => navigate('/app/templates'));
  useChord(['g', 's'], () => navigate('/app/sends'));
  useChord(['g', 'e'], () => navigate('/app/ab'));
  useChord(['g', 'a'], () => navigate('/app/automations'));

  if (!user || !token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--paper-2)' }}>
      <AppSidebar />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Outlet />
      </main>
      <CommandPalette />
    </div>
  );
}
